<template>
	<div style="padding: 30px">
		<el-form :inline="true" :model="formSearch" ref="formSearch" class="demo-form-inline">
			<el-form-item label="政策法规名称">
				<el-input placeholder="请输入政策法规名称" v-model="formSearch.pdiciesName" autocomplete="off"></el-input>
			</el-form-item>
			<el-form-item label="分类名称">
				<el-select placeholder="分类名称" v-model="formSearch.pdiciesSortId">
					<el-option label="全部" value=""></el-option>
					<el-option :label="item.name" :value="item.pdicies_sort_id" v-for="(item, index) in sortAll"
						:key="index"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="是否发布" style="display: none">
				<el-select placeholder="是否发布" v-model="formSearch.state">
					<el-option value="0" label="全部"></el-option>
					<el-option value="1" label="是"></el-option>
					<el-option value="2" label="否"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" @click="getTableDate(1)">查询</el-button>
			</el-form-item>
		</el-form>
		<el-button type="primary" @click="handleAdd">添加政策法规</el-button>
		<el-dialog title="政策法规添加" :visible.sync="dialogFormVisible" width="800px">
			<el-form :model="formInfo" ref="formInfo" :rules="rules">
				<el-form-item label="政策法规名称" :label-width="formLabelWidth" prop="pdiciesName">
					<el-input v-model="formInfo.pdiciesName" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="政策法规分类" :label-width="formLabelWidth" prop="pdiciesSortId">
					<el-select v-model="formInfo.pdiciesSortId" placeholder="请选择政策法规分类" style="width: 100%">
						<el-option :label="item.name" :value="item.pdicies_sort_id" v-for="(item, index) in sortAll"
							:key="index"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="政策法规排序" :label-width="formLabelWidth" prop="sort">
					<el-input type="number" v-model="formInfo.sort" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="是否发布" :label-width="formLabelWidth" style="display: none">
					<el-radio v-model="formInfo.state" label="1">是</el-radio>
					<el-radio v-model="formInfo.state" label="2">否</el-radio>
				</el-form-item>
				<el-form-item label="政策法规简介" :label-width="formLabelWidth" prop="pdiciesSynopsis">
					<el-input v-model="formInfo.pdiciesSynopsis" type="textarea" :autosize="{ minRows: 4 }"></el-input>
				</el-form-item>
				<el-form-item label="政策法规内容" :label-width="formLabelWidth" prop="pdiciesContent">
					<tinymce ref="mychild"></tinymce>
				</el-form-item>
				<el-form-item label="政策法规封面" :label-width="formLabelWidth">
					<el-upload class="avatar-uploader" :action="pictureUpload" :show-file-list="false"
						:auto-upload="false" :on-change="handleChange">
						<img v-if="formInfo.pictureVisable" :src="formInfo.pictureUrl" class="avatar" />
						<i v-else class="el-icon-plus avatar-uploader-icon"></i>
					</el-upload>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogFormVisible = false">取 消</el-button>
				<el-button type="primary" @click="submitForm">确 定</el-button>
			</div>
		</el-dialog>
		<el-table :data="tableData" border stripe style="width: 100%; margin-top: 20px">
			<el-table-column prop="pdicies_name" label="政策法规名称" min-width="180"></el-table-column>
			<el-table-column prop="pdicies_sort_id" label="分类名称" :formatter="nameChange" min-width="100"></el-table-column>
			<el-table-column label="封面图" min-width="80">
				<template slot-scope="scope">
					<img :src="imgRealUrl(scope)" style="height: 50px" />
				</template>
			</el-table-column>
			<el-table-column prop="sort" label="排序" min-width="80"></el-table-column>
			<el-table-column prop="state" label="是否发布" :formatter="stateChange" min-width="80"></el-table-column>
			<el-table-column label="操作" width="300">
				<template slot-scope="scope">
					<el-button size="mini"  plain type="success" @click="preview(scope)" style="margin-left: 10px;">预览</el-button>
					<el-button size="mini" type="primary" plain v-if="scope.row.state != 1" @click="handleReport(scope, 1)">发布
					</el-button>
					<el-button size="mini" type="info" plain v-else @click="handleReport(scope, 2)">取消</el-button>
					<el-button size="mini" type="warning" plain @click="handleEdit(scope)">编辑</el-button>
					<el-button size="mini" type="danger" plain @click="handleDelete(scope)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>
		<el-pagination style="margin-top: 10px" background @size-change="handleSizeChange"
			@current-change="handleCurrentChange" :current-page="tablePageInfo.currentPage"
			:page-sizes="[10, 20, 50, 100]" :page-size="tablePageInfo.pageSize"
			layout="total, sizes, prev, pager, next, jumper" :total="tablePageInfo.total">
		</el-pagination>
		
		<el-dialog title="预览" width="1100px" :visible.sync="dialogPreviewVisible">
			<PoliceContentPreview ref="preview"></PoliceContentPreview>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="dialogPreviewVisible = false">关闭</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import Tinymce from "@components/tinymce.vue";
	import PoliceContentPreview from "@components/policeContentPreview";
	export default {
		components: {
			Tinymce: Tinymce,
			PoliceContentPreview
		},
		data() {
			return {
				tableData: [],
				tablePageInfo: {
					pageSize: 10, //每页的条数
					total: 0, //总条数
					currentPage: 1, //当前页
				},
				formSearch: {
					pdiciesName: "",
					state: "",
					pdiciesSortId: "",
					page: 1,
					limit: 10,
				},
				sortAll: [],
				dialogFormVisible: false,
				pictureUpload: "sina/admin/pdicies/addPdicies", //上传图片接口
				formInfo: {
					pdiciesName: "",
					pdiciesSortId: "", //新闻分类id
					sort: "",
					state: "2",
					pdiciesSynopsis: "", //新闻简介
					pdiciesContent: "", //新闻内容
					pictureUrl: "", //查看的图片url
					pictureVisable: false, //查看的图片url
					pictures: "", //上传的图片
				},
				rules: {
					name: [{
						required: true
					}],
					pdicies_sort_id: [{
						required: true
					}],
					sort: [{
						required: true
					}],
					pdiciesSynopsis: [{
						required: true
					}], //新闻简介
					pdiciesContent: [{
						required: true
					}], //新闻内容
					pictureUrl: [{
						required: true
					}],
				},
				formLabelWidth: "120px",
				buttonFun: "addPdicies",
				dialogPreviewVisible:false,
			};
		},
		methods: {
			getTableDate: function(res) {
				var that = this;
				if (res != "") {
					that.formSearch.page = 1;
				} //点击查询，恢复第一页
				this.$axios
					.post(this.baseUrl + "admin/pdicies/searchPdicies", that.formSearch)
					.then((response) => {
						if (response.data.code != "200") {
							that.$alert(response.data.msg, "提示", {
								confirmButtonText: "确定",
							});
						} else {
							that.tablePageInfo.total = response.data.data.count;
							that.tableData = response.data.data.res;
						}
					})
					.catch(function(error) {
						window.console.log(error);
					}); //ajax请求失败
			},
			//选择图片，图片变化
			handleChange(event) {
				this.formInfo.pictures = event.raw;
				var testmsg = /^image\/(jpeg|png|jpg)$/.test(event.raw.type);
				if (!testmsg) {
					this.$message.error("上传头像图片只能是 jpeg|png|jpg 格式!");
					return false;
				}
				console.log(event.url);
				let url = "";
				if (window.createObjectURL != undefined) {
					url = window.createObjectURL(event.raw);
				} else if (window.URL != undefined) {
					url = window.URL.createObjectURL(event.raw);
				} else if (window.webkitURL != undefined) {
					url = window.webkitURL.createObjectURL(event.raw);
				}
				console.log(url);
				this.formInfo.pictureVisable = true;
				this.formInfo.pictureUrl = url;
			},
			//增加新闻
			handleAdd() {
				(this.buttonFun = "addPdicies"), (this.dialogFormVisible = true);
				this.formInfo = {
					pdiciesName: "",
					pdiciesSortId: "", //新闻分类id
					sort: "",
					state: "2",
					pdiciesSynopsis: "", //新闻简介
					pdiciesContent: "", //新闻内容
					pictureUrl: "", //查看的图片url
					pictureVisable: false, //查看的图片url
					pictures: "", //上传的图片
				};
				if (this.$refs["formInfo"] !== undefined) {
					this.$refs["formInfo"].resetFields();
				}
				this.$nextTick(() => {
					this.$refs.mychild.myValue = "";
				});
			},
			//编辑新闻
			handleEdit(scope) {
				(this.buttonFun = "updatePdicies"),
				(this.formInfo = {
					pdiciesId: scope.row.pdicies_id,
					pdiciesName: scope.row.pdicies_name,
					pdiciesSortId: scope.row.pdicies_sort_id, //新闻分类id
					sort: scope.row.sort,
					state: scope.row.state.toString(),
					pdiciesSynopsis: scope.row.pdicies_synopsis, //新闻简介
					pdiciesContent: scope.row.pdicies_content, //新闻内容
					pictureUrl: this.imgRealUrl(scope),
					pictures: "",
					pictureVisable: true, //查看的图片url
				});
				this.$nextTick(() => {
					this.$refs.mychild.myValue = scope.row.pdicies_content;
				});
				this.dialogFormVisible = true;
			},
			/*changeWang(html) {
			  this.formInfo.pdiciesContent = html;
			},*/ //子组件fuwenben向父组件传值
			//删除新闻
			handleDelete(scope) {
				var that = this;
				this.$confirm("确定删除吗?", "提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning",
				}).
				then(() => {
					that.$axios.get(this.baseUrl + "admin/pdicies/deletePdicies?pdiciesId=" + scope.row.pdicies_id)
						.
					then((response) => {
						if (response.data.code == "200") {
							that.getTableDate();
						}
						that.$alert(response.data.msg, "提示", {
							confirmButtonText: "确定"
						});
					}).catch(function(error) {
						window.console.log(error);
					}); //ajax请求失败
				}).catch(() => {})
			},

			//发布新闻
			handleReport(scope, state) {
				var that = this;
				this.$axios
					.get(
						this.baseUrl +
						"admin/pdicies/ReleasePdicies?pdiciesId=" +
						scope.row.pdicies_id +
						"&state=" +
						state
					)
					.then((response) => {
						if (response.data.code == "200") {
							that.getTableDate();
						}
						that.$alert(response.data.msg, "提示", {
							confirmButtonText: "确定"
						});
					})
					.catch(function(error) {
						window.console.log(error);
					}); //ajax请求失败
			},
			//增加编辑提交表单
			submitForm() {
				var that = this;
				that.formInfo.pdiciesContent = this.$refs.mychild.myValue;
				let param = new FormData();
				if (this.buttonFun == "updatePdicies") {
					param.append("pdiciesId", that.formInfo.pdiciesId);
				}
				param.append("pictures", that.formInfo.pictures);
				param.append("pdiciesName", that.formInfo.pdiciesName),
					param.append("pdiciesSortId", that.formInfo.pdiciesSortId), //新闻分类id
					param.append("sort", that.formInfo.sort),
					param.append("state", parseInt(that.formInfo.state)),
					param.append("pdiciesSynopsis", that.formInfo.pdiciesSynopsis), //新闻简介
					param.append("pdiciesContent", this.$refs.mychild.myValue), //新闻内容
					this.$refs["formInfo"].validate((valid) => {
						if (valid) {
							this.$axios
								.post(this.baseUrl + "admin/pdicies/" + this.buttonFun, param, {
									headers: {
										"Content-Type": "multipart/form-data"
									},
								})
								.then((response) => {
									if (response.data.code == "200") {
										that.dialogFormVisible = false;
										that.getTableDate();
									}
									that.$alert(response.data.msg, "提示", {
										confirmButtonText: "确定",
									});
								})
								.catch(function(error) {
									window.console.log(error);
								}); //ajax请求失败
						} else {
							console.log("error submit!!");
							return false;
						}
					});
			},
			handleSizeChange(val) {
				this.formSearch.limit = val;
				this.getTableDate("");
			}, //每页条数发生改变
			handleCurrentChange(val) {
				this.formSearch.page = val;
				this.getTableDate("");
			}, //翻页
			stateChange(row) {
				if (row.state == 1) {
					return "是";
				} else {
					return "否";
				}
			}, //是否发布
			nameChange(row) {
				for (var i = 0; i < this.sortAll.length; i++) {
					if (this.sortAll[i].police_sort_id == row.police_sort_id) {
						return this.sortAll[i].name;
					}
				}
			},
			imgRealUrl(scope) {
				return this.baseUrl2 + "uploads/" + scope.row.picture;
			}, //图片真实地址
			preview(scope){
				this.dialogPreviewVisible=true;
				var that=this;
				setTimeout(function(){that.$refs.preview.preview(scope.row.pdicies_id);},200)
			},
		},
		beforeMount: function() {
			var that = this;
			this.$axios
				.post(this.baseUrl + "admin/pdicies/searchPdiciesSort")
				.then((response) => {
					if (response.data.code != "200") {
						that.$alert(response.data.msg, "提示", {
							confirmButtonText: "确定"
						});
					} else {
						that.sortAll = response.data.data.res;
					}
				})
				.catch(function(error) {
					window.console.log(error);
				}); //ajax请求失败
			this.getTableDate("");
		},
	};
</script>
<style scoped>
	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409eff;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 178px;
		height: 178px;
		line-height: 178px;
		text-align: center;
	}

	.avatar {
		width: 178px;
		height: 178px;
		display: block;
	}

	.el-icon-plus {
		border: 1px solid #d9d9d9;
		border-radius: 6px;
	}
</style>
